const beach = {
  50: '#F5F4F1',
  100: '#E6E3DD',
  200: '#D5D1C7',
  300: '#C4BFB0',
  400: '#B7B19F',
  500: '#AAA38E',
  600: '#A39B86',
  700: '#99917B',
  800: '#908871',
  900: '#7F775F',
  A100: '#FFFBF0',
  A200: '#FEEDBD',
  A400: '#FFE08A',
  A700: '#FFD970'
};

export default beach;
